(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crystal-grid-sales-home"] && !Shopify.designMode) return;
  try {
    

for(const s of document.querySelectorAll('#cg-sales [data-grid]')){let a='<g fill="none" stroke="#aa8b56" stroke-width="1.4"><circle cx="300" cy="300" r="225"/>';if(s.dataset.grid==='moon'){a+='<path d="M354 90 A214 214 0 1 0 354 510 A175 214 0 0 1 354 90 Z"/><circle cx="300" cy="300" r="100"/>';}else{a+='<circle cx="300" cy="300" r="100"/>';for(let i=0;i<6;i++){const t=i*Math.PI/3;a+=`<circle cx="${300+100*Math.sin(t)}" cy="${300-100*Math.cos(t)}" r="100"/>`;}}a+='</g>';const colors=s.dataset.grid==='moon'?['#cbd6da','#927bb6','#44434c']:['#cbd6da','#90aa88','#d4ae56'];for(let i=0;i<7;i++){const t=(i-1)*Math.PI/3,x=i?300+110*Math.sin(t):300,y=i?300-110*Math.cos(t):300,k=i?26:39;a+=`<g transform="translate(${x} ${y}) rotate(${i*30})"><g class="demo-stone demo-stone-${i}"><path d="M0 ${-k} L${k*.55} ${-k*.42} L${k*.43} ${k*.62} L0 ${k} L${-k*.48} ${k*.48} L${-k*.5} ${-k*.4} Z" fill="${colors[i%3]}"/><path d="M0 ${-k} L${k*.12} ${-k*.28} L${k*.15} ${k*.65} L0 ${k} L${-k*.15} ${k*.1} Z" fill="#ffffff55"/></g></g>`;}s.innerHTML=a;}


const demo=document.querySelector('#cg-sales .hero-art');
const toggle=demo?.querySelector('.demo-toggle');
toggle?.addEventListener('click',()=>{const paused=demo.classList.toggle('demo-paused');toggle.setAttribute('aria-pressed',String(paused));toggle.textContent=paused?'Play Animation':'Pause Animation';});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
